import { render, staticRenderFns } from "./RequestsReport.vue?vue&type=template&id=12401efd"
import script from "./RequestsReport.vue?vue&type=script&lang=js"
export * from "./RequestsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports